// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"_16Xt7"};


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/Page/PageComponents/Luft/Luft.scss
 ** module id = 459
 ** module chunks = 0
 **/